import { useDispatch, useSelector } from "react-redux";
import CheckListAccordian from "../../../components/Accordian/ChecklistAccordian";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
  Modal,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { useTQuery } from "../../../utils/useTQuery";
import { setcheckListDatail } from "../../../slice/checkListSlice";

export default function ChecklistModal({ open, handleClose, specialityID }) {
  const dispatch = useDispatch();
  const { checkListDatails } = useSelector((state) => state?.checkListDatail);
  const { selectedTabData } = useSelector((state) => state.profileTabSection);
  const { controlBy, controlAction, controlUser } = useSelector(
    (state) => state.user,
  );
  const [specialityChecklist, setspecialityChecklist] = useState([]);
  const [specialityName, setSpecialityName] = useState("");
  const [getClinicianData, setGetClinicianData] = useState([]);
  const { userDetails } = useSelector((state) => state.user);
  const [checkList, setCheckLIst] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // const { data: check, refetch: fetchAgain, isLoading: isApiLoading } = useTQuery(
  //   [specialityID],
  //   `/fetchClinicianChecklist?${new URLSearchParams({
  //     specialityID: specialityID,
  //     clinicianID: controlBy === "admin" ? controlUser : userDetails?.ID
  //   }).toString()}`,
  //   'get',
  // );

  // ✅ ChecklistModal.js
  const {
    data: check,
    refetch: fetchAgain,
    isLoading: isApiLoading,
  } = useTQuery(
    ["checklist", specialityID], // 👈 add prefix to make key unique
    `/fetchClinicianChecklist?${new URLSearchParams({
      specialityID: specialityID,
      clinicianID: controlBy === "admin" ? controlUser : userDetails?.ID,
    }).toString()}`,
    "get",
    { enabled: !!specialityID }, // 👈 only fetch when specialityID exists
  );

  useEffect(() => {
    if (open && specialityID) {
      setIsLoading(true);
      fetchAgain().finally(() => {
        setIsLoading(false);
      });
      if (!check?.OUTPUT) {
        setTimeout(() => {
          setCheckLIst(selectedTabData?.checkListData);
        }, 500);
      }
    }
  }, [open, specialityID, check, fetchAgain, selectedTabData]);

  useEffect(() => {
    setSpecialityName(check?.OUTPUT?.speciality?.SPECIALTY_NAME);
    setGetClinicianData(check?.OUTPUT?.fetchJob || []);
  }, [check, specialityID, userDetails?.ID]);

  useEffect(() => {
    if (!getClinicianData?.length) return;

    const groupedChecklists = getClinicianData?.reduce((acc, job) => {
      const {
        checklistName,
        checklistDiscription,
        checklistTtile,
        checklistOption,
        answer,
      } = job;

      if (!acc[checklistTtile]) {
        acc[checklistTtile] = {
          checklistName,
          checklistDiscription,
          checklistTtile,
          checklistStatus: null,
          checklistOptions: [],
        };
      }

      acc[checklistTtile].checklistOptions?.push({
        checklistOption,
        answer,
        optionID: job.optionID,
      });

      return acc;
    }, {});

    if (groupedChecklists) {
      const groupedChecklistsArray = Object?.values(groupedChecklists);
      setspecialityChecklist(groupedChecklistsArray);
    }
  }, [getClinicianData]);

  useEffect(() => {
    if (!specialityChecklist?.length) return;
    const result = {
      ID: check?.OUTPUT?.fetchJob?.[0]?.specialityID,
      SPECIALTY_NAME: specialityName,
      specialityChecklist: specialityChecklist,
    };
    dispatch(setcheckListDatail(specialityChecklist));
    setCheckLIst(result);
  }, [
    specialityChecklist,
    specialityName,
    check,
    specialityID,
    userDetails?.ID,
    dispatch,
  ]);

  const handleDownloadPDF = () => {
    const printWindow = window.open("", "_blank");
    const modalContent = document.getElementById("checklist-modal-content");

    if (printWindow && modalContent) {
      const content = modalContent.innerHTML;
      const styles = `
        <style>
          @page { 
            margin: 0; 
            size: A4;
          }
          @media print {
            @page { 
              margin: 0; 
              size: A4;
            }
            * {
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            body { 
              margin: 15mm;
              padding: 0;
            }
            thead { display: table-header-group; }
            tfoot { display: table-footer-group; }
            @top-left { content: ""; }
            @top-center { content: ""; }
            @top-right { content: ""; }
            @bottom-left { content: ""; }
            @bottom-center { content: ""; }
            @bottom-right { content: ""; }
          }
          body { font-family: Arial, sans-serif; margin: 20px; }
          .checklist-title { font-size: 18px; font-weight: bold; margin-bottom: 10px; }
          .checklist-description { margin-bottom: 20px; }
          .checklist-section { margin-bottom: 30px; border: 1px solid #ddd; padding: 15px; }
          .section-title { font-size: 16px; font-weight: bold; margin-bottom: 15px; }
          .checklist-item { margin-bottom: 15px; }
          .item-text { font-size: 14px; margin-bottom: 10px; }
          .checkbox-grid { display: flex; gap: 10px; align-items: center; }
          .checkbox { width: 20px; height: 20px; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; }
          .checkbox.checked { background-color: #6cb94c; color: white; }
          .checkbox.disabled { background-color: #f5f5f5; color: #999; }
          .rating-button { width: 25px; height: 25px; border-radius: 50%; border: 1px solid #ccc; display: inline-flex; align-items: center; justify-content: center; margin: 0 5px; }
          .rating-button.selected { background-color: #6cb94c; color: white; }
          .rating-button.not-selected { background-color: #f5f5f5; color: #666; }
          hr { margin: 20px 0; }
        </style>
      `;

      let pdfContent = `
        <html>
          <head>
            <title>${checkList?.SPECIALTY_NAME || "Checklist"} PDF</title>
            ${styles}
          </head>
          <body>
            <div class="checklist-title">${checkList?.SPECIALTY_NAME || "Checklist"}</div>
            <div class="checklist-description">${checkList?.specialityChecklist?.[0]?.checklistDiscription?.replace(/\r?\n/g, "<br>") || ""}</div>
            <hr>
      `;

      // Generate checklist content
      checkList?.specialityChecklist?.forEach((section, sectionIndex) => {
        pdfContent += `
          <div class="checklist-section">
            <div class="section-title">${section.checklistTtile || ""}</div>
        `;

        // Add header checkboxes
        pdfContent += `<div class="checkbox-grid">`;
        ["1", "2", "3", "4"].forEach((rating, i) => {
          const isChecked = false; // Header checkboxes are not selected in modal
          pdfContent += `
            <div class="checkbox ${isChecked ? "checked" : "disabled"}">
              ${isChecked ? "✓" : ""}
            </div>
          `;
        });
        pdfContent += `</div><br>`;

        // Add checklist items
        section.checklistOptions?.forEach((item, itemIndex) => {
          pdfContent += `
            <div class="checklist-item">
              <div class="item-text">${item.checklistOption || ""}</div>
              <div class="checkbox-grid">
          `;

          ["1", "2", "3", "4"].forEach((rating, ratingIndex) => {
            const isSelected = item.answer === (ratingIndex + 1).toString();
            pdfContent += `
              <div class="rating-button ${isSelected ? "selected" : "not-selected"}">
                ${rating}
              </div>
            `;
          });

          pdfContent += `</div></div>`;
        });

        pdfContent += `</div>`;
      });

      pdfContent += `
          </body>
        </html>
      `;

      printWindow.document.write(pdfContent);
      printWindow.document.close();
      printWindow.focus();

      // Try to remove headers and footers
      printWindow.onload = function () {
        setTimeout(() => {
          printWindow.document.title = ""; // Remove title
          printWindow.print();

          // Close after printing
          printWindow.onafterprint = function () {
            printWindow.close();
          };

          // Fallback close
          setTimeout(() => {
            printWindow.close();
          }, 1000);
        }, 500);
      };
    }
  };
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: 800,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    maxHeight: "90vh",
    overflowY: "auto",
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="checklist-modal-title"
      aria-describedby="checklist-modal-description"
    >
      <Box sx={modalStyle} id="checklist-modal-content">
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "rgba(0,0,0,0.54)",
            "&:hover": {
              color: "rgba(0,0,0,0.87)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
        {isLoading || isApiLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={200}
          >
            <CircularProgress sx={{ color: "#6ebe44" }} />
          </Box>
        ) : (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 2 }}
            >
              <Typography
                id="checklist-modal-title"
                sx={{
                  fontSize: "18px",
                  color: "rgba(0,0,0,0.87)",
                  fontWeight: 700,
                }}
              >
                {checkList?.SPECIALTY_NAME}
              </Typography>
              <Button
                variant="outlined"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadPDF}
                sx={{
                  border: "1px solid #6ebe44",
                  color: "#6ebe44",
                  "&:hover": {
                    backgroundColor: "#6ebe44",
                    color: "white",
                  },
                }}
              >
                Download PDF
              </Button>
            </Box>

            <Typography
              id="checklist-modal-description"
              dangerouslySetInnerHTML={{
                __html:
                  checkList?.specialityChecklist?.[0]?.checklistDiscription?.replace(
                    /\r?\n/g,
                    "",
                  ) || "",
              }}
              sx={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
                width: "100%",
                maxWidth: "670px",
                mb: 2,
              }}
            />

            <hr />

            {checkList?.specialityChecklist?.length > 0 ? (
              <CheckListAccordian option={checkList} disabled={true} />
            ) : (
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "rgba(0,0,0,0.87)",
                  fontWeight: 400,
                  display: "flex",
                  my: 4,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No Checklist Found for this Speciality.
              </Typography>
            )}

            <Box display="flex" justifyContent="end" sx={{ mt: 4 }}>
              <Stack spacing={2} direction="row">
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  sx={{ border: "1px solid lightgrey", color: "#6ebe44" }}
                >
                  Close
                </Button>
              </Stack>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
